const MODAL_CONTAINER_ATTRIBUTE = 'data-modal';
const MODAL_SHOW_ATTRIBUTE = 'data-open-modal';
const MODAL_CLOSE_ATTRIBUTE = 'data-close-modal';

const POPUP_SHOW_CLASS = 'popup-content--open';
const PAGE_NO_SCROLL_CLASS = 'popup-opened';

const WRAPPER_CLASS = 'popup-layout';

const POPUP_LOADED_EVENT_NAME = 'popupLoaded';

const PopupSetting = {
    closeByClickOutside: true,
};

const popupLoadedEvent = new Event(POPUP_LOADED_EVENT_NAME);

document.addEventListener('DOMContentLoaded', (function () {
    const pageElement = document.querySelector('html') || document.querySelector('body');
    const modalElements = document.querySelectorAll(`[${MODAL_CONTAINER_ATTRIBUTE}]`);

    if (!modalElements.length) {
        return;
    }

    modalElements.forEach(function (modalElement) {
        const modalName = modalElement.getAttribute(`${MODAL_CONTAINER_ATTRIBUTE}`);
        const closeButtonElements = modalElement.querySelectorAll(`[${MODAL_CLOSE_ATTRIBUTE}]`);
        const modalParentElement = modalElement.parentNode;
        const oldPlaceElement = document.createElement('div');
        const modalWrapperElement = document.createElement('div');
        const closeCallbacks = [];

        Object.assign(modalElement, {
            popup: {
                isOpened: false,
                open: openPopup,
                close: closePopup,
                addCloseCallback: addCloseCallback,
            }
        });

        oldPlaceElement.style.display = 'none';

        modalWrapperElement.classList.add(WRAPPER_CLASS);

        function movePopupToShow() {
            modalParentElement.insertBefore(oldPlaceElement, modalElement);
            modalWrapperElement.appendChild(modalElement);
            pageElement.insertBefore(modalWrapperElement, pageElement.firstChild);
            modalElement.classList.add(POPUP_SHOW_CLASS);
            pageElement.classList.add(PAGE_NO_SCROLL_CLASS);
        }

        function movePopupToHide() {
            pageElement.classList.remove(PAGE_NO_SCROLL_CLASS);
            modalElement.classList.remove(POPUP_SHOW_CLASS);
            modalParentElement.insertBefore(modalElement, oldPlaceElement);
            modalWrapperElement.remove();
            oldPlaceElement.remove();
        }

        function removeHandlers() {
            document.removeEventListener('keydown', escKeyDownHandler);

            if (PopupSetting.closeByClickOutside) {
                modalWrapperElement.removeEventListener('click', wrapperClickHandler);
            }

            closeButtonElements.forEach(function (buttonElement) {
                buttonElement.removeEventListener('click', closeButtonClickHandler);
            })
        }

        function addHandlers() {
            document.addEventListener('keydown', escKeyDownHandler);

            if (PopupSetting.closeByClickOutside) {
                modalWrapperElement.addEventListener('click', wrapperClickHandler);
            }

            closeButtonElements.forEach(function (buttonElement) {
                buttonElement.addEventListener('click', closeButtonClickHandler);
            })
        }

        function openPopup() {
            if (!modalElement.popup.isOpened) {
                movePopupToShow();
                setTimeout(function() {
                    addHandlers();
                    modalElement.popup.isOpened = true;
                }, 0);
            }
        }

        function closePopup() {
            if (modalElement.popup.isOpened) {
                movePopupToHide();
                removeHandlers();
                initCloseCallback();

                modalElement.popup.isOpened = false;
            }
        }

        function initCloseCallback() {
            if (closeCallbacks.length) {
                closeCallbacks.forEach(function (closeCallbackFunction) {
                    if (typeof closeCallbackFunction === 'function') {
                        closeCallbackFunction();
                    }
                });
            }
        }

        function escKeyDownHandler(evt) {
            if (evt.key === 'Escape') {
                evt.preventDefault();

                closePopup();
            }
        }

        function wrapperClickHandler(evt) {
            if (evt.target.classList.contains(WRAPPER_CLASS)) {
                evt.preventDefault();

                closePopup();
            }
        }

        function closeButtonClickHandler(evt) {
            evt.preventDefault();

            closePopup();
        }

        function addCloseCallback(callback) {
            closeCallbacks.push(callback);
        }
    });

    document.addEventListener('click', function (evt) {
        const openBtn = evt.target.closest(`[${MODAL_SHOW_ATTRIBUTE}]`);
        if (openBtn) {
            evt.preventDefault();
            const modalName = openBtn.getAttribute(MODAL_SHOW_ATTRIBUTE);
            const modalElement = document.querySelector(`[${MODAL_CONTAINER_ATTRIBUTE}="${modalName}"]`);

            if (modalElement && modalElement.popup) {
                modalElement.popup.open();
            }
        }
    });

    window.dispatchEvent(popupLoadedEvent);
}));
